
import React from "react";

export const Footer = () => {
  return (
    <footer className="w-full bg-white py-6 px-6 border-t">
      <div className="max-w-7xl mx-auto flex items-center justify-center">
        <p className="text-tribal-neutral font-medium">
          2025 TRIBAL TRAILS.AI
        </p>
      </div>
    </footer>
  );
};
